import React from "react";
import { View, Pressable } from "react-native";
import { useRouter } from "expo-router";
import { Text } from "../Text";
import { useTranslateText } from "@/app/utils";
import { headerStyles as styles } from "./styles";

interface HeaderProps {
  showBackButton?: boolean;
}

const Header: React.FC<HeaderProps> = ({ showBackButton = true }) => {
  const router = useRouter();
  const { t } = useTranslateText();

  return (
    <View style={styles.container}>
      {showBackButton && (
        <Pressable
          testID="pickupDriveThruBackButton"
          accessibilityRole="button"
          accessibilityLabel={t("tpos.pickupDriveThru.back")}
          onPress={() => router.back()}
          style={styles.backButton}
        >
          <Text style={styles.backButtonText}>
            {t("tpos.pickupDriveThru.back")}
          </Text>
        </Pressable>
      )}
      <Text style={styles.title}>{t("tpos.pickupDriveThru.title")}</Text>
    </View>
  );
};

export default Header;
